module.exports = __webpack_public_path__ + "static/media/newellauto.f1139aad.gif";


//////////////////
// WEBPACK FOOTER
// ./src/pages/PortfolioPage/images/newellauto.gif
// module id = 352
// module chunks = 0